module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"applicationLabel":"Application form","reservationsLabel":"My reservations","infoLabel":"Information about resorts"},"fi":{"applicationLabel":"Lomapaikkahakemus","reservationsLabel":"Vahvistetut varaukset","infoLabel":"Lisätietoja lomapaikoista"}}')
  delete Component.options._Ctor
}
